// @flow
import React from "react"
import { compose } from "react-apollo"
import { Switch, Route } from "react-router-dom"
import { Toolbar, Heading, PriorLink } from "../UI/Toolbar"
import { TabBar, Tab } from "../UI/TabBar"
import { Page } from "../UI/Page"
import Loader from "../UI/Loader"
import queries from "./queries"
import AttractLoopFormView from "./AttractLoopFormView"
import type { AttractLoopViewProps } from "./types"
import Slides from "../Slides"

class AttractLoopView extends React.Component<AttractLoopViewProps> {
  render() {
    const {
      match: { params: { id }, url },
      details,
      history: { location: { pathname } }
    } = this.props
    return (
      <Page>
        <Loader loading={details ? details.loading : false}>
          <Toolbar>
            <PriorLink to="/admin/attract-loops">Attract Loops</PriorLink>
            <Heading>
              {id && details ? (
                `${details.attractLoop ? details.attractLoop.title : ""}`
              ) : (
                "New Attract Loop"
              )}
            </Heading>
          </Toolbar>
          {id ? (
            <TabBar>
              <Tab pathname={pathname} to={`${url}/slides`}>
                Slides
              </Tab>
              <Tab pathname={pathname} to={`${url}`} exact>
                Details
              </Tab>
            </TabBar>
          ) : (
            <span />
          )}
          <Switch>
            <Route path={`${url}/slides`} component={Slides(id || "")} />
            <Route component={AttractLoopFormView} />
          </Switch>
        </Loader>
      </Page>
    )
  }
}

export default compose(queries.withAttractLoopFormDetails)(AttractLoopView)



// WEBPACK FOOTER //
// ./src/AttractLoops/AttractLoopView.js